import { __decorate, __metadata } from "tslib";
import { foaf, vcard } from '@openhps/rdf';
import { DataFrame, DataObject, SerializableMember, SerializableObject } from '@openhps/core';
let SolidProfileObject = class SolidProfileObject extends DataObject {
    constructor(webId, displayName) {
        super(webId, displayName);
    }
    /**
     * Unique WebID
     */
    get webId() {
        return this.uid;
    }
    set webId(value) {
        this.uid = value;
    }
    get name() {
        var _a;
        return (_a = this._formattedName) !== null && _a !== void 0 ? _a : `${this.firstName} ${this.lastName}`;
    }
    set name(name) {
        this._formattedName = name;
    }
    /**
     * Get the profile document URL without trailing hashtag
     * @returns {URL} Profile URL
     */
    get profileDocumentUrl() {
        try {
            const profileDocumentUrl = new URL(this.webId);
            profileDocumentUrl.hash = '';
            return profileDocumentUrl;
        }
        catch (error) {
            console.error(error);
            return undefined;
        }
    }
};
__decorate([
    SerializableMember({
        rdf: {
            predicates: [vcard.given_name, foaf.givenname],
        },
    }),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "firstName", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicates: [vcard.family_name, foaf.surname],
        },
    }),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "lastName", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicates: [vcard.fn, foaf.name],
        },
    }),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "_formattedName", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicates: [foaf.nick],
        },
    }),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "nickname", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: [vcard.hasPhoto],
        },
    }),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "picture", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "oidcIssuer", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", String)
], SolidProfileObject.prototype, "sessionId", void 0);
SolidProfileObject = __decorate([
    SerializableObject({
        rdf: {
            type: foaf.Person,
        },
    }),
    __metadata("design:paramtypes", [String, String])
], SolidProfileObject);
export { SolidProfileObject };
/* Add the WebID attribute to the DataObject prototype, and allow serialization */
DataObject.prototype.webId = undefined;
SerializableMember(String)(DataObject.prototype, 'webId');
/* Add the WebID attribute to the DataFrame prototype, and allow serialization */
DataFrame.prototype.webId = undefined;
SerializableMember(String)(DataFrame.prototype, 'webId');
//# sourceMappingURL=SolidProfileObject.js.map